/* istanbul ignore file */

import MUITab from '@mui/material/Tab';
import { styled } from '../styles';

const Tab = styled(MUITab)(({ theme: { typography, breakpoints, spacing } }) => ({
  textTransform: 'none',
  minWidth: 64,
  '&&': {
    fontWeight: typography.body.fontWeight,
  },
  '&.MuiTab-root': {
    padding: spacing(1.5, 1),
    [breakpoints.up('sm')]: {
      padding: spacing(1.5, 2),
    },
  },
  '&.Mui-selected': {
    fontWeight: typography.button.fontWeight,
  },
}));

export default Tab;
